// const {  toast } = require("react-hot-toast");
const { apiConnector } = require("../apiconnector");
const { geminiLinks } = require("../apis");
const {
  addBotReply,
  addUserText,
  toggleBotTyping,
} = require("../../reducer/Slices/ChatBotSlice");

export const getGeminiResponse = (userPrompt, user,allCoursesDetails) => {
  return async (dispatch) => {
    dispatch(toggleBotTyping());
    dispatch(addUserText(userPrompt));
    const courseDetails = JSON.stringify(allCoursesDetails);
    let systemPrompt = `
You are a helpful support assistant for StudyNotion, an e-learning platform created by Chayan Mallick. 
Always speak as a representative of StudyNotion. Do not leak sensitive information.

Courses offered:
${courseDetails}

Support Contact:
📧 Email: info@studynotion.com 
📞Phone details
Mon - Fri From 8am to 5pm
+123 456 7869
Office Details
Come and say hello at our office HQ.
Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016

NOTE :- ALL PRICES ARE IN ₹

Now answer the following user question:
${userPrompt}
`;

if (user && typeof user === 'object') {
  const userDetails = JSON.stringify(user, null, 2);
  systemPrompt += `\n\nUser Info:\n${userDetails}`;
}

    if (user) {
      const userDetails = JSON.stringify(user,null,2);
      systemPrompt += `\n\nUser Info : ${userDetails}`;
    }
    console.log("User Prompt -> ", userPrompt);
    const body = {
      body: {
        contents: [
          {
            parts: [{ text: systemPrompt }],
          },
        ],
      },
      headers: {
        "Content-Type": "application/json",
      },
    };
    await apiConnector("POST", geminiLinks.GEMINI_API_LINK_BACKEND, body)
      .then((res) => {
        const chat_answers = res.data.data.candidates[0].content.parts;
        dispatch(addBotReply(chat_answers));
      })
      .catch((err) => {
        console.error("Some Error Occurred");
        //toast.error('Some Problem With Bot Try Again Later');
      });
    dispatch(toggleBotTyping());
  };
};
